import React from 'react'
import { Tabs, TabButton } from '@mobi/component-library/Navigation/Tabs'
import { CustomizeBet } from './CustomizeBet'
import { QuickPick } from './QuickPick'

export const MysteryBetTabs: React.FC = () => {
  const [currentTab, setCurrentTab] = React.useState<TabNavs>('Quick Pick')
  const tabNavigationRef = React.useRef<TabNavs[]>(['Quick Pick', 'Customise Bet'])

  return (
    <>
      <Tabs>
        {tabNavigationRef.current.map(tab => (
          <TabButton
            key={tab}
            content={tab}
            isSelected={currentTab === tab}
            onClick={() => setCurrentTab(tab)}
            testId={tab}
          />
        ))}
      </Tabs>

      {currentTab === 'Quick Pick' && <QuickPick />}
      {currentTab === 'Customise Bet' && <CustomizeBet />}
    </>
  )
}

// =====
// Types
// =====

type TabNavs = 'Quick Pick' | 'Customise Bet'
